module.exports = __webpack_public_path__ + "img/SES_CS-SLIMLINER-Assemby.dd9685ea.jpg";